var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"px-1",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('router-link',{attrs:{"to":{ name: item.href }}},[_c('div',[_vm._v(_vm._s(item.text))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }